/* eslint-disable no-param-reassign */
import {select} from "../../../../../shared/SagaService";
import { Type } from "../../../helper";

export function* parseContactTypes(transactionType, transaction = {}) {
    const contacts = yield select(state => state.List.contacts);
    const invalidArr = [];
    let invalidName;

    if (transaction.contact_id) {
        // get the saved name first
        invalidName = transaction.autosave_text_values.contact_id;
        switch (transactionType) {
            // all contacts
            case Type.bank_income:
            case Type.bank_expense:
            case Type.journal_entry: {
                if (!contacts.find(contact => contact.id === transaction.contact_id))
                    invalidArr.push(invalidName);
                break;
            }
            // customer
            case Type.sale_quote:
            case Type.sale_order:
            case Type.sale_delivery_order:
            case Type.sale_invoice:
            case Type.sale_credit_note:
            case Type.sale_payment:
            case Type.sale_refund:
            case Type.contra: {
                const contact = contacts.find(contact => contact.id === transaction.contact_id);
                if (!(contact && contact.types.includes("customer")))
                    invalidArr.push(invalidName);
                break;
            }
            // supplier
            case Type.purchase_order:
            case Type.purchase_goods_received_note: {
                const contact = contacts.find(contact => contact.id === transaction.contact_id);
                if (!(contact && contact.types.includes("supplier")))
                    invalidArr.push(invalidName);
                break;
            }
            // supplier/employee
            case Type.purchase_credit_note:
            case Type.purchase_payment:
            case Type.purchase_refund: {
                const contact = contacts.find(contact => contact.id === transaction.contact_id);
                if (!(contact &&
                    (contact.types.includes("supplier") || contact.types.includes("employee")))
                )
                    invalidArr.push(invalidName);
                break;
            }
            // dynamic
            case Type.purchase_bill: {
                if (transaction.payment_mode === 'claim' &&
                !contacts.find(contact => contact.id === transaction.contact_id)?.types.includes("employee")
                )
                    invalidArr.push(invalidName);
                if (transaction.payment_mode !== 'claim' &&
                !contacts.find(contact => contact.id === transaction.contact_id)?.types.includes("supplier")
                )
                    invalidArr.push(invalidName);
                break;
            }
            default:
                break;
        }
    }

    // at this point, if invalidArr has length, means has invalid contact. If so, we can remove the contact_id from transaction.
    if (invalidArr.length !== 0)
        transaction.contact_id = null;

    // Check contact2_id
    if (transaction.contact2_id) {
        invalidName = transaction.autosave_text_values.contact2_id;
        switch (transactionType) {
            // supplier
            case Type.purchase_bill:
                if (!contacts.find(contact => contact.id === transaction.contact2_id)?.types.includes("supplier")) {
                    transaction.contact2_id = null;
                    invalidArr.push(invalidName);
                }
                break;
            // supplier/employee
            case Type.contra: {
                const contact = contacts.find(contact => contact.id === transaction.contact2_id);
                if (!(contact &&
                       (contact.types.includes("supplier") || contact.types.includes("employee")))
                ) {
                    transaction.contact2_id = null;
                    invalidArr.push(invalidName);
                }
                break;
            }
            default:
                break;
        }
    }

    return invalidArr;
}
